"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var baseStyle = {
  icon: {
    color: 'primary.default'
  },
  button: {
    display: 'flex',
    gridGap: 3.5,
    alignItems: 'center',
    fontSize: 'sm',
    fontWeight: 'semibold',
    _hover: {
      backgroundColor: 'gray.50'
    }
  },
  container: {
    borderColor: 'gray.medium'
  }
};
var variants = {
  lined: {
    button: {
      px: 2,
      py: 3
    },
    container: {
      borderTopWidth: 1,
      _last: {
        borderBottomWidth: 1
      }
    },
    panel: {
      px: 2,
      py: 3
    }
  },
  contained: {
    button: {
      px: 4,
      py: 3
    },
    container: {
      borderLeftWidth: 1,
      borderRightWidth: 1,
      _first: {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4
      },
      _last: {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4
      }
    },
    panel: {
      p: 4,
      borderColor: 'gray.medium',
      borderTopWidth: 1
    }
  }
};
var defaultProps = {
  variant: 'lined'
};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.Accordion, {
  variants: variants,
  baseStyle: baseStyle,
  defaultProps: defaultProps
});